import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function PaidDefenseIndemnityFeesForm({ location }) {
  console.log('PaidDefenseIndemnityFeesForm rendered: ', location)

  let init = {
    invoiceDateFrom: '',
    invoiceDateTo: '',
    invoicePaidFrom: '',
    invoicePaidTo: '',
    dateAssignedFrom: '',
    dateAssignedTo: '',
    status: [],
    scheduled: '',
    classification: [],
    settlementDateFrom: '',
    settlementDateTo: '',
    closedDateFrom: '',
    closedDateTo: '',
    amountOperator: '',
    settlementAmount: '',
    disease: [],
    settlementType: 'S',
    orderBy: '1',
    orderDir: 'ASC'
  }

  const navigate = useNavigate()
  init = initialFormValues('PaidDefenseIndemnityFeesForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('PaidDefenseIndemnityFeesForm', navigate, inputs, 'defense_fees.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Liberty Mutual Defense Fees Report' />
            <tbody>
              <DateRangeInput label='Invoice Date' name='invoiceDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoiceDateFrom} defaultValueTo={inputs.invoiceDateTo} />
              <DateRangeInput label='Paid Date' name='invoicePaid' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoicePaidFrom} defaultValueTo={inputs.invoicePaidTo} />
              <DateRangeInput label='Date Assigned' name='dateAssigned' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateAssignedFrom} defaultValueTo={inputs.dateAssignedTo} />
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='status' multiple={true} defaultValue={inputs.status} />
              <tr>
                <td><b>Was Claim Ever Scheduled For Trial</b></td>
                <td> <Input
                  type="select"
                  name="scheduled"
                  onChange={handleInputChange}
                  style={{ width: 'auto' }}
                  defaultValue={inputs.scheduled}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <CustomSelectListInput label="Classification" handleChange={handleInputChange} modelName="Asbestos" entityName="opp_firm_type" name='classification' multiple={true} defaultValue={inputs.classification} />
              <DateRangeInput label='Settlement Date' name='settlementDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.settlementDateFrom} defaultValueTo={inputs.settlementDateTo} />
              <DateRangeInput label='Date Closed' name='closedDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.closedDateFrom} defaultValueTo={inputs.closedDateTo} />
              <tr>
                <td><b>Settlement Amount</b></td>
                <td>
                  <Input
                    type="select"
                    name="amountOperator"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.amountOperator}
                  >
                    <option value={''}></option>
                    <option value={'>'}>Greater Than</option>
                    <option value={'='}>Equal To</option>
                    <option value={'<'}>Less Than</option>
                  </Input>
                  <Input style={{ width: 'auto', display: 'inline-block' }} name="settlementAmount" onChange={handleInputChange} defaultValue={inputs.settlementAmount} />
                </td>
              </tr>
              <CustomSelectListInput label="Current Diagnosis" handleChange={handleInputChange} modelName="Asbestos" entityName="injury" name='disease' multiple={true} defaultValue={inputs.disease} />
              <tr>
                <td><b>Settlement Data Source</b></td>
                <td>
                  <Input
                    type="select"
                    name="settlementType"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.settlementType}
                  >
                    <option value={'S'}>Use Settlement Tab Data</option>
                    <option value={'D'}>Use Settlement Detail Data</option>
                  </Input>
                </td>
              </tr>
              <tr>
                <td colSpan={2}><b>Note: </b>
                  Selecting "Use Settlement Tab Data" will cause the report to use the values from the "Settlement Amount" and "Settlement Date" fields under the "Settlement" tab.   Selecting "Use Settlement Detail Data" will cause the report to use the values from the "Settlement Amount" and "Settlement Date" fields under the "Settlement Details" list with the following logic:   If no "Settlement Date" parameters are specified, only the most recent settlement amount is used.   If either, or both, "Settlement Date" parameters are specified, they are used to sum only the settlement amounts with a "Settlement Date" value within the specified date range.
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

